import { useState } from 'react';
import { SHORTCUT_LABEL_MAX } from '@tradeoutlet/shared';
import { DialogFooter, Field, Input, Modal, useDialogSave } from '@/components/ui';

/** t607u: the one name dialog, for saving a page (Add to My Shortcuts) and renaming a shortcut. Save and Cancel. */
export function ShortcutNameDialog({ title, initial, onSave, onClose }: { title: string; initial: string; onSave: (label: string) => Promise<unknown>; onClose: () => void }) {
  const [name, setName] = useState(initial);
  const { saving, error, run } = useDialogSave(onClose);
  const ok = name.trim().length > 0;
  const submit = () => { if (ok && !saving) void run(() => onSave(name.trim())); };
  return (
    <Modal open onClose={onClose} title={title}
      footer={<DialogFooter onCancel={onClose} onSave={submit} saving={saving} disabled={!ok} error={error} saveTestId="shortcut-save" />}>
      <Field label="Name">
        <Input autoFocus maxLength={SHORTCUT_LABEL_MAX} value={name} onChange={e => setName(e.target.value)} data-testid="shortcut-name"
          onFocus={e => e.currentTarget.select()} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); submit(); } }} />
      </Field>
    </Modal>
  );
}
